<template>
  <IconLucideRotateCcw />
</template>
